import { jsx as _jsx } from "react/jsx-runtime";
import { capitalize } from '@iotv/core-services';
import { canonicalizeDayMask, dayMaskTemplate } from '@iotv/iotv-v3-types';
import { Stack, Typography } from '@mui/material';
export const DayMaskSummary = ({ dayMask }) => {
    const canonicalDayMask = dayMask ? canonicalizeDayMask(dayMask) : dayMaskTemplate;
    return (_jsx(Stack, { height: 1, direction: 'row', alignItems: 'center', gap: 0.5, children: Object.entries(canonicalDayMask).map(([k, v], i) => (_jsx(Typography, { sx: {
                aspectRatio: 1 / 1,
                width: '1.5em',
                lineHeight: '1.5em',
                textAlign: 'center',
                color: (t) => (v ? t.palette.primary.contrastText : t.palette.text.disabled),
                backgroundColor: (t) => (v ? t.palette.primary.main : t.palette.action.disabledBackground),
            }, children: capitalize(k.at(0)) }, `${i}_${k}`))) }));
};
